import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";

// Cascading taxonomy selector (cached via react-query so it loads instantly on repeat opens)
export default function TaxonomySelect({ value, onChange, levels = ["exam", "subject", "chapter"] }) {
  const [cat, setCat] = useState("");
  const opt = { staleTime: 5 * 60 * 1000 };
  const { data: cats = [] } = useQuery({ queryKey: ["tax", "category"], queryFn: () => get("/taxonomy?level=category"), ...opt });
  const { data: exams = [] } = useQuery({ queryKey: ["tax", "exam", cat], queryFn: () => get(`/taxonomy?level=exam&parent_id=${cat}`), enabled: !!cat, ...opt });
  const { data: subjects = [] } = useQuery({ queryKey: ["tax", "subject", value.exam_id], queryFn: () => get(`/taxonomy?level=subject&parent_id=${value.exam_id}`), enabled: !!value.exam_id, ...opt });
  const { data: chapters = [] } = useQuery({ queryKey: ["tax", "chapter", value.subject_id], queryFn: () => get(`/taxonomy?level=chapter&parent_id=${value.subject_id}`), enabled: !!value.subject_id, ...opt });

  const Sel = ({ label, val, opts, on, tid }) => (
    <label className="block"><span className="text-xs font-semibold text-slate-600">{label}</span>
      <select value={val || ""} onChange={(e) => on(e.target.value)} data-testid={tid} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2 text-sm bg-white">
        <option value="">Select...</option>{opts.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
      </select>
    </label>
  );
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <Sel label="Category" val={cat} opts={cats} on={setCat} tid="tax-category" />
      {levels.includes("exam") && <Sel label="Exam" val={value.exam_id} opts={exams} on={(v) => onChange({ ...value, exam_id: v, subject_id: "", chapter_id: "" })} tid="tax-exam" />}
      {levels.includes("subject") && <Sel label="Subject" val={value.subject_id} opts={subjects} on={(v) => onChange({ ...value, subject_id: v, chapter_id: "" })} tid="tax-subject" />}
      {levels.includes("chapter") && <Sel label="Chapter" val={value.chapter_id} opts={chapters} on={(v) => onChange({ ...value, chapter_id: v })} tid="tax-chapter" />}
    </div>
  );
}
